__turbopack_context__.v({
  "className": "lexend_d1aa6e3c-module__XXip1a__className",
});
